























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import { CloseButtonConfigVO } from "@/model/FormWheel";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
  },
})
export default class CloseButtonSetting extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  value!: CloseButtonConfigVO;

  @Prop({ type: String, default: "" })
  pageType!: string;

  @Prop({ type: String, default: "" })
  defaultIconColor!: string;

  get iconColorDefault(): string {
    return this.defaultIconColor || "#333333";
  }

  get defaultConfig(): CloseButtonConfigVO {
    return {
      position: "right-top",
      bgMode: "none",
      bgColor: "rgba(0,0,0,0)",
      iconColor: this.iconColorDefault,
      size: "18px",
    };
  }

  config: CloseButtonConfigVO = {};

  initConfig() {
    this.config = {
      ...this.defaultConfig,
      ...this.value,
    };
  }

  positionOptions = [
    { value: "left-top", label: "左上角" },
    { value: "right-top", label: "右上角" },
  ];

  bgModeOptions = [
    { value: "none", label: "无" },
    { value: "circle", label: "圆形" },
    { value: "square", label: "方形" },
  ];

  sizeOptions = [
    { value: "18px", label: "18px" },
    { value: "20px", label: "20px" },
    { value: "22px", label: "22px" },
    { value: "24px", label: "24px" },
    { value: "26px", label: "26px" },
    { value: "28px", label: "28px" },
    { value: "30px", label: "30px" },
    { value: "32px", label: "32px" },
    { value: "34px", label: "34px" },
    { value: "36px", label: "36px" },
    { value: "38px", label: "38px" },
    { value: "40px", label: "40px" },
  ];

  predefineColors = [
    "#000000",
    "#333333",
    "#666666",
    "#999999",
    "#CCCCCC",
    "#FFFFFF",
    "#FF0000",
    "#00FF00",
    "#0000FF",
    "#FFFF00",
    "#FF00FF",
    "#00FFFF",
    "#C30D23",
    "#0F1222",
    "#513EFF",
    "rgba(0,0,0,0)",
    "rgba(0,0,0,0.5)",
    "rgba(255,255,255,0.8)",
  ];

  @Watch("value", { immediate: true, deep: true })
  onValueChange() {
    this.initConfig();
  }

  @Watch("defaultIconColor", { immediate: true })
  onDefaultIconColorChange() {
    if (!this.value?.iconColor) {
      this.initConfig();
    }
  }

  handleChange() {
    this.$emit("input", { ...this.config });
    this.$emit("change", { ...this.config });
  }

  handleChangeWithGtag() {
    this.handleChange();
    window?.gtagClick?.(
      "form_edit_setCloseButtonSize",
      `弹窗_编辑订阅工具_设置关闭按钮尺寸_${this.pageType}`
    );
  }
}
